import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useQuery } from "@tanstack/react-query";
import { classNames as cx } from "primereact/utils";

import quickbookLogo from "../../../assets/images/quickbooks_logo.png";
import { requests } from "../../../services/http-common";

import styles from "./Integrations.module.scss";

export function QuickBooks() {
  const { data, isLoading } = useQuery<{ isExpired: boolean }>({
    queryFn: () => {
      return requests.get(`/quickbooks/auth`);
    },
  });

  if (!data) {
    return null;
  }

  return (
    <Card className={styles.card}>
      <h4 className={styles.header}>Connect Your Account!</h4>
      <div className={styles.content}>
        <p className={styles.info}>
          Connect your account now to start enjoying the Daigle Operating
          Systems features. Its the only way for the system to be able to read
          your data and act upon it.
        </p>
        <div className={styles.actions}>
          <a
            className={cx(styles.button, {
              [styles.disabled]: !data.isExpired || isLoading,
            })}
            href={`${process.env.REACT_APP_DSC_SERVICE_URL}/quickbooks/sign-in?currentPageUrl=${window.location.href}`}
          >
            <Button
              label={data.isExpired ? "Connect" : "Connected"}
              aria-label="create-lead"
              className="p-button-sm"
              disabled={!data.isExpired || isLoading}
            />
          </a>
          <img src={quickbookLogo} alt="quickbookLogo" />
        </div>
      </div>
    </Card>
  );
}
